import React from 'react';
import PropTypes from 'prop-types';
import {
  Body,
  Box,
} from '../../coreui';

const InvestmentTypeDefinition = ({
  investmentType,
}) => {
  const definitions = {
    funded: {
      label: 'Funded',
      text: 'investments are active investments that have received full funding and are not currently accepting further investment.',
      blurb: null,
    },
    // eslint-disable-next-line camelcase
    completed_equity: {
      label: 'Completed',
      text: 'investments have concluded and final distributions have been processed.',
      blurb: null,
    },
    // eslint-disable-next-line camelcase
    completed_debt: {
      label: 'Completed',
      text: 'investments have concluded and final distributions have been processed.',
      blurb: 'RealtyMogul no longer offers residential investment opportunities and only provides commercial investment opportunities. Residential investments are only shown for historical purposes.',
    },
  };

  const selectedDefinition = definitions[investmentType];

  return (
    <Box
      pt={40}
      px={[40, 20]}
      w={1}
    >
      <Body
        type="B1"
        color="gray.8"
        m={0}
        display="block"
        fontStyle="italic"
        align="center"
      >
        { `"${selectedDefinition.label}" ` }
        { selectedDefinition.text }
      </Body>
      {
        selectedDefinition.blurb &&
        <Body
          type="B5"
          color="gray.8"
          m={0}
          mt={[16, 6]}
          display="block"
          align="center"
        >
          { selectedDefinition.blurb }
        </Body>
      }
    </Box>
  );
};

InvestmentTypeDefinition.propTypes = {
  investmentType: PropTypes.oneOf([
    'completed_equity',
    'completed_debt',
    'funded',
  ]),
};

export default InvestmentTypeDefinition;
